import { Z as w, D as x, E as A, w as E, O as G, F as d, J as I, s as O, bw as h, I as l, Y as T, V, d7 as $, bv as j, aC as k, cY as F, db as J, dc as R, dd as Y } from "./schemaGCService-BPDgpUKC.js";
/*!
 * @dineug/erd-editor
 * @version 3.3.0 | Thu Oct 15 2026
 * @author SeungHwan-Lee <dineug2@gmail.com>
 * @license MIT
 */
const z = {
  change: "change"
};
function H(p) {
  const o = /* @__PURE__ */ new Set(), b = w(p), t = x(b, !1), u = A(t), c = new E(), m = new G(
    (e) => t.subscribe((n) => e.next(n))
  ).pipe(d(l), I(200)), a = /* @__PURE__ */ new Set(), S = new F(), g = (e) => (a.has(e) || a.add(e), () => {
    a.delete(e);
  }), f = (e, n) => {
    a.forEach((s) => {
      const r = Reflect.get(s, e);
      T(r, n);
    });
  }, y = (e) => {
    const n = $(e);
    t.dispatchSync(
      j(k(n) ? "{}" : n)
    ), S.run(h(t.state)).then((s) => {
      (s.tableIds.length || s.tableColumnIds.length || s.relationshipIds.length || s.indexIds.length || s.indexColumnIds.length || s.memoIds.length) && (J(t.state, s), t.dispatchSync(R()));
    });
  }, i = (e) => {
    c.next([e].flat());
  }, C = (e) => {
    V(() => i(e));
  }, v = () => {
    Array.from(o).forEach((e) => e.unsubscribe()), o.clear(), a.clear(), t.destroy(), u.destroy();
  };
  return o.add(m.subscribe(() => f(z.change, void 0))).add(
    c.pipe(
      d(l),
      O((e) => e.map((n) => Y(n, "tags")))
    ).subscribe(t.dispatchSync)
  ), Object.freeze({
    get value() {
      return h(t.state);
    },
    on: g,
    setInitialValue: y,
    dispatch: C,
    dispatchSync: i,
    destroy: v
  });
}
export {
  H as createReplicationStore
};
